import {FC, ReactNode} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'

type FormMessageProps = {
  description: ReactNode
  icon?: ReactNode
  label?: ReactNode
  title?: string
  titleColor?: string
  backgroundColor?: string
  borderColor?: string
}

export const FormMessage: FC<React.PropsWithChildren<FormMessageProps>> = ({
  description,
  icon,
  label,
  title,
  titleColor = theme.palette.text.default,
  backgroundColor,
  borderColor,
}) => {
  return (
    <>
      <div className="message">
        {icon && <div className="icon">{icon}</div>}
        <div>
          {label && <div className="label">{label}</div>}
          {title && (
            <div className="title">
              <Text
                variant={TextVariant.text14}
                fontWeight={TextFontWeight.bold}
                color={titleColor}
              >
                {title}
              </Text>
            </div>
          )}
          {description}
        </div>
      </div>

      <style jsx>{`
        .message {
          display: flex;
          padding: ${theme.spacing[3]};
          background-color: ${backgroundColor};
          border-radius: 12px;
          ${borderColor ? `box-shadow: inset 0px 0px 0px 1px ${borderColor}` : ''};
        }
        .message + .message {
          margin-top: ${theme.spacing[4]};
        }
        .icon {
          margin-right: 12px;
        }
        .label {
          display: inline-block;
          margin-bottom: ${theme.spacing[2.5]};
        }
        .title {
          margin-bottom: ${theme.spacing[1]};
        }
      `}</style>
    </>
  )
}
